import { toast } from 'sonner';
import { Button, Card, CardBody, Eyebrow, IconTile, Pill } from '@/shared/components';
import type { StripeSettingsResponse } from '@/shared/api';
import { I } from '@/shared/icons';
import { getDoctorMessage, getStatusPresentation } from './stripeSettingsPresentation';

interface StripeStatusCardProps {
  settings: StripeSettingsResponse;
}

export function StripeStatusCard({ settings }: StripeStatusCardProps) {
  const status = getStatusPresentation(settings.status);

  return (
    <Card variant="dark" className="mb-6 overflow-hidden">
      <CardBody className="p-6">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div className="flex items-start gap-3">
            <IconTile variant="accent" size="md">
              <I name="Webhook" size={20} />
            </IconTile>
            <div>
              {/* Auf Navy trägt `fg-dim` (= ink-soft) knapp 1,3:1 — die Zeile war praktisch
                  unsichtbar. Auf dunklen Flächen gelten die On-Dark-Tokens (§2). */}
              <Eyebrow variant="sub" className="text-paper/70">
                Verbindungsstatus
              </Eyebrow>
              <h2 className="text-paper mt-1 font-serif text-xl">
                {settings.accountLabel ?? 'Stripe noch nicht eingerichtet'}
              </h2>
            </div>
          </div>
          <Pill variant={status.variant}>{status.label}</Pill>
        </div>
        <p className="text-paper/80 mt-5 max-w-2xl text-sm">
          {settings.lastCheckMessage
            ? getDoctorMessage(settings.lastCheckMessage)
            : 'Speichern Sie die Schlüssel und prüfen Sie die Verbindung vor dem ersten Zahlungsvorgang.'}
        </p>
        {settings.webhookUrl && (
          <div className="border-paper/20 mt-5 flex flex-wrap items-center gap-3 border-t pt-4">
            <code className="text-paper min-w-0 flex-1 break-all text-xs">
              {settings.webhookUrl}
            </code>
            <Button
              variant="ghost-dark"
              size="sm"
              onClick={() => void copyWebhookUrl(settings.webhookUrl!)}
            >
              Webhook-URL kopieren
            </Button>
          </div>
        )}
      </CardBody>
    </Card>
  );
}

async function copyWebhookUrl(url: string) {
  try {
    await navigator.clipboard.writeText(url);
    toast.success('Webhook-URL kopiert');
  } catch {
    toast.error('Webhook-URL konnte nicht kopiert werden');
  }
}
